import React, { PureComponent } from 'react';
import { IMAGES_REPO } from '../../config';

class Header extends PureComponent {

  render() {
    const { body, photo1 } = this.props;
    return (
      <header className="header" style={{ backgroundImage: `url(${IMAGES_REPO}${photo1})` }}>
        <div className="container">
          <div className="intro-text">
            <div className="header__body" dangerouslySetInnerHTML={{ __html: body }}/>
          </div>
        </div>
      </header>
    );
  }
}

Header.propTypes = {};
Header.defaultProps = {};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js